<template>
  <div>
    <callout
      :has-toggle="true"
      class="mb-3 mt-1"
      :border-color="getStatusColor(itemsEval.referralStatusId)"
    >
      <div class="row mt-2">
        <div
          class="col-md-2 col-sm-12 d-flex justify-content-center align-items-center"
        >
          <custom-balloon
            class="px-3"
            :text="itemsEval.status"
            :background-color="
              `bg-${getStatusColor(itemsEval.referralStatusId)}`
            "
          />
        </div>
        <div class="col-md-2 col-sm-12">
          <div class="font-weight-normal font-16 color-black--2">
            {{ itemsEval.discipline }}
          </div>
          <p class="font-weight-normal font-14 color-gray--6">
            {{ itemsEval.evaluationType }}
          </p>
        </div>
        <div class="col-md-2 col-sm-12">
          <div class="font-weight-normal font-14 color-gray--6">
            Fecha:
          </div>
          <span class="font-weight-normal font-16 color-black--2">
            {{ $formatDate(itemsEval.date, $templateDate.default) }}
          </span>
        </div>
        <div class="col-md-2 col-sm-12">
          <div class="font-weight-normal font-14 color-gray--6">
            Solicitado por:
          </div>
          <span class="font-weight-normal font-16 color-black--2">
            {{ itemsEval.requestedBy }}
          </span>
          /
          <span class="font-weight-normal font-16 color-black--2 font-italic">
            {{ $formatDate(itemsEval.requestedDate, $templateDate.default) }}
          </span>
        </div>
        <div class="col-md-2 col-sm-12 text-right pr-5">
          <action-button
            v-if="isPendingSignature(itemsEval.referralStatusId)"
            i="fas fa-file-import"
            variant="outline-success m-2"
            @click="$emit('on-enter', itemsEval)"
          >
            Entrar
          </action-button>
          <action-button
            v-else
            i="fas fa-print"
            variant="outline-success m-2"
            @click="$emit('on-download-referral-report', itemsEval.id)"
          >
            Imprimir
          </action-button>
        </div>
        <div class="col-md-2 col-sm-12 text-right pr-5">
          <action-button
            v-if="canDelete(itemsEval.referralStatusId)"
            i="fas fa-times-circle"
            variant="outline-danger btn-cancel danger m-2"
            @click="$emit('on-delete')"
          >
            Eliminar
          </action-button>
        </div>
      </div>
      <template #edition>
        <div class="bg-gray p-2">
          <div class="bg-white rounded p-3">
            <div v-if="itemsEval.appointmentNumber">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <em class="fas fa-info-circle text-orange mr-2" />
                  <span class="color-black--3 font-weight-bold font-16">
                    Comentario
                  </span>
                </div>
                <div class="col ml-4 mt-n3">
                  <span class="font-weight-normal font-16 color-black--2">
                    {{ itemsEval.comment }}
                  </span>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-md-12 mb-3">
                  <em class="fas fa-info-circle text-orange mr-2" />
                  <span class="color-black--3 font-weight-bold font-16">
                    Información del Cita
                  </span>
                </div>
                <div class="col-md-12">
                  <div class="row ml-2">
                    <div class="col-md-4">
                      <div class="font-weight-normal font-14 color-gray--6">
                        Número:
                      </div>
                      <span class="font-weight-normal font-16 color-black--2">
                        {{ itemsEval.appointmentNumber }}
                      </span>
                    </div>
                    <div class="col-md-4 pt-2">
                      <div class="font-weight-normal font-14 color-gray--6">
                        Especialista:
                      </div>
                      <span class="font-weight-normal font-16 color-black--2">
                        {{ itemsEval.appointmentSpecialist }}
                      </span>
                    </div>
                    <div class="col-md-4 pt-2">
                      <div class="font-weight-normal font-14 color-gray--6">
                        Lugar:
                      </div>
                      <span class="font-weight-normal font-16 color-black--2">
                        {{ itemsEval.appointmentPlace }}
                      </span>
                    </div>
                  </div>
                  <div class="row ml-2 mt-3">
                    <div class="col-md-4">
                      <div class="font-weight-normal font-14 color-gray--6">
                        Fecha y Hora:
                      </div>
                      <span class="font-weight-normal font-16 color-black--2">
                        <span>
                          {{
                            $formatDate(
                              itemsEval.appointmentTimeStart,
                              $templateDate.numberMonthDayYear
                            )
                          }}
                        </span>
                        <br />
                        <i>
                          {{
                            $formatDate(
                              itemsEval.appointmentTimeStart,
                              $templateDate.hour
                            )
                          }}
                          -
                        </i>
                        <i>
                          {{
                            $formatDate(
                              itemsEval.appointmentTimeEnd,
                              $templateDate.hour
                            )
                          }}
                        </i>
                      </span>
                    </div>
                    <div class="col-md-4 pt-2">
                      <div class="font-weight-normal font-14 color-gray--6">
                        Cita Coordinada por:
                      </div>
                      <span class="font-weight-normal font-16 color-black--2">
                        {{ itemsEval.appointmentCoordinatedBy }}
                      </span>
                    </div>
                    <div class="col-md-4 pt-2">
                      <div class="font-weight-normal font-14 color-gray--6">
                        Corporación:
                      </div>
                      <span class="font-weight-normal font-16 color-black--2">
                        {{ itemsEval.appointmentCompany }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row px-4" :class="{ alt: alt }">
                <div class="col-4 pl-4 pb-3">
                  <span>La cita no ha sido coordinada.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </callout>
  </div>
</template>

<script>
import Callout from '@/components/common/callout/View.vue';
import { CustomBalloon } from '@/components/common';
import ActionButton from '@/components/common/ActionButton';
import rpStatuses from '@/utils/constants/rp/rpStatuses';
import referralStatus from '@/utils/constants/pei/referral/referralStatus';

export default {
  name: 'ReferralEvaluationRow',
  components: {
    Callout,
    CustomBalloon,
    ActionButton,
  },
  props: {
    alt: {
      type: Boolean,
      default: () => false,
    },
    itemsEval: {
      type: Object,
      default: () => ({
        discipline: '',
        evaluationType: '',
        date: null,
        comment: '',
        appointmentNumber: '',
        appointmentSpecialist: '',
        appointmentPlace: '',
        appointmentTimeStart: null,
        appointmentTimeEnd: null,
        appointmentCoordinatedBy: '',
        appointmentCompany: '',
      }),
    },
  },
  computed: {
    getStatusColor() {
      return (status) => {
        switch (status) {
          case rpStatuses.Nuevo:
            return 'secondary-23';
          case referralStatus.pendingSignature:
            return 'yellow-2';
          case rpStatuses.Denegado:
            return 'secondary-24';
          case rpStatuses.Cita_Coordinada:
          case rpStatuses.Procesado:
          case rpStatuses.Aprobado:
          case rpStatuses.ReCoordinar_Cita:
            return 'primary-15';
          case rpStatuses.Referido_a_Remedio_Provisional:
            return 'primary-12';
          case rpStatuses.Inactivo:
            return 'secondary-24';
          case rpStatuses.AprobadoEnRempro:
            return 'secondary-25';
          default:
            return 'secondary-6';
        }
      };
    },
    canDelete() {
      return (statusId) => statusId === rpStatuses.Nuevo;
    },
    isPendingSignature() {
      return (statusId) => statusId === referralStatus.pendingSignature;
    },
  },
};
</script>

<style scoped>
.dropdown-item {
  padding: 0.5rem 1.5rem;
}
.alt {
  background-color: #fafbfa;
}
.pointer {
  cursor: pointer;
}
.re-row {
  height: 80px;
}
.fs-13 {
  font-size: 13px;
}
.re-icon {
  font-size: 21px;
  font-weight: 900;
}
.re-icon.expanded {
  color: #2db782;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
  font: 700 14px/17px Lato;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #b5c3bc;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: transparent;
}
</style>
